import React, { forwardRef } from 'react';
import './Input.scss';

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
  type: 'text' | 'email';
  label?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  defaultValue?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = 'text',
      label,
      name,
      placeholder,
      required,
      className = '',
      defaultValue = '',
      value,
      ...props
    },
    ref
  ) => {
    return (
      <label className={'c-input ' + className}>
        {label && <span className='c-input-label'>{`${label} ${required ? '*' : ''}`}</span>}
        <input
          ref={ref}
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          className='c-input-field'
          defaultValue={defaultValue}
          value={value}
          {...props}
        />
      </label>
    );
  }
);
